import React, { useMemo } from "react";
import styled, { keyframes } from "styled-components";
import Button from "../components/Button";
import Card from "../components/Card";
import Status from "../types/enum/Status";
import Icon from "../components/Icon";
import FlexBox, { FlexGrow } from "../components/FlexBox";
import SignInImage from "../assets/signin.svg";
import AstroImageSrc from "../assets/astro.png";
import LogoImage from "../assets/logonew3.png";
import { useScreenClass } from "react-grid-system";

const SignText = styled.div`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 42px;
  /* identical to box height, or 105% */
  text-transform: uppercase;
  /* Neutral/$color-text-primary */
  color: #e6e6e6;
  margin-bottom: 24px;
`;
const SignInCard = styled(Card)`
  padding: 0;
  margin-top: 0;
  width: 100%;
  min-height: 100vh;
`;
const animate = keyframes`
0%{
  transform: translateY(0) rotate(0deg);
  opacity: 1;
  border-radius: 0;
}

100%{
  transform: translateY(-1000px) rotate(720deg);
  opacity: 0;
  border-radius: 50%;
}
`;
const AstroImage = styled.img`
  position: absolute;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  animation: ${animate} 25s linear infinite;
  bottom: -150px;
  &:nth-child(1) {
    left: 25%;
    width: 80px;
    height: 80px;
    animation-delay: 0s;
  }

  &:nth-child(2) {
    left: 10%;
    width: 20px;
    height: 20px;
    animation-delay: 2s;
    animation-duration: 12s;
  }

  &:nth-child(3) {
    left: 70%;
    width: 20px;
    height: 20px;
    animation-delay: 4s;
  }

  &:nth-child(4) {
    left: 40%;
    width: 60px;
    height: 60px;
    animation-delay: 0s;
    animation-duration: 18s;
  }

  &:nth-child(5) {
    left: 65%;
    width: 20px;
    height: 20px;
    animation-delay: 0s;
  }

  &:nth-child(6) {
    left: 75%;
    width: 110px;
    height: 110px;
    animation-delay: 3s;
  }

  &:nth-child(7) {
    left: 35%;
    width: 150px;
    height: 150px;
    animation-delay: 7s;
  }

  &:nth-child(8) {
    left: 50%;
    width: 25px;
    height: 25px;
    animation-delay: 15s;
    animation-duration: 45s;
  }

  &:nth-child(9) {
    left: 20%;
    width: 15px;
    height: 15px;
    animation-delay: 2s;
    animation-duration: 35s;
  }

  &:nth-child(10) {
    left: 85%;
    width: 150px;
    height: 150px;
    animation-delay: 0s;
    animation-duration: 11s;
  }
`;
const AstroContain = styled.div`
  position: absolute;
  top: 0;
  left: 30%;
  width: 70%;
  height: 100%;
  overflow: hidden;
`;
const SignInButton = styled(Button)`
  border: 1px solid #e7ebee;
  border-radius: 8px;
  width: 340px;
  color: #e7ebee;
  padding: 10px 26px;
  font-family: Inter;
  background-color: transparent;
  &:hover:not(:disabled) {
    background: rgba(14, 16, 63, 0.91) 47.63%;
    -webkit-text-decoration: none;
    text-decoration: none;
    color: #E5E5E5;
}
}
`;

function SignInPage() {
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ["xs", "sm", "md"].includes(screenClass),
    [screenClass]
  );
  localStorage.clear();
  return (
    <>
      <SignInCard>
        <FlexBox
          space={2}
          style={{
            minHeight: "100vh",
            padding: "0 28px",
            background:
              "linear-gradient(75.68deg, #C54B4D 0%, rgba(14, 16, 63, 0.91) 47.63%, rgba(14, 16, 63, 0.12) 95.81%)",
          }}
        >
          <FlexGrow>
            <img src={LogoImage} alt="" style={{ marginBottom: "24px" }} />
            <SignText>Sign In To A1CE</SignText>

            <SignInButton
              as="a"
              href={process.env.REACT_APP_AICE_BASE_URL + "/login"}
            >
              {/* <Button status={Status.primary} as="a" href="https://hub-staging.cmkl.ac.th/oauth/login"> */}
              {/* <Icon name="google" mr={1} /> */}
              Sign In
            </SignInButton>
           
          </FlexGrow>
        </FlexBox>

        {!isMobile && (
          <AstroContain>
            <AstroImage src={AstroImageSrc} />
            <AstroImage src={AstroImageSrc} />
            <AstroImage src={AstroImageSrc} />
            <AstroImage src={AstroImageSrc} />
            <AstroImage src={AstroImageSrc} />
            <AstroImage src={AstroImageSrc} />
            <AstroImage src={AstroImageSrc} />
            <AstroImage src={AstroImageSrc} />
            <AstroImage src={AstroImageSrc} />
            <AstroImage src={AstroImageSrc} />
          </AstroContain>
        )}
      </SignInCard>
    </>
  );
}

export default SignInPage;
